import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function MapStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M21.95 6.15C21.15 5.33 20.03 5.33 18 5.33H15.92C15.4267 5.33 14.9567 5.22 14.51 5L11.17 3.34C9.81 2.66 9.02 2.28 8.15 2.26C8.1 2.26 8.05 2.25 8 2.25C7.95 2.25 7.89 2.26 7.84 2.26C6.97 2.33 6.21 2.77 4.88 3.54L3.65 4.26C2.58 4.88 1.99 5.22 1.62 5.87C1.25 6.52 1.25 7.21 1.25 8.46V16.62C1.25 18.32 1.25 19.18 1.76 19.81C2.1 20.23 2.58 20.52 3.11 20.61C3.92 20.76 4.64 20.33 6.1 19.49L6.22 19.42C6.99 18.97 7.65 18.58 8.41 18.68C8.76 18.73 9.19 18.94 10.03 19.36L13.84 21.26C14.77 21.72 14.89 21.75 15.92 21.75H18C20.03 21.75 21.15 21.75 21.95 20.92C22.75 20.11 22.75 18.97 22.75 16.91V10.17C22.75 8.11 22.75 6.97 21.95 6.15ZM7.25 17.3C6.59 17.47 6.01 17.81 5.47 18.12L5.35 18.19C4.39 18.74 3.64 19.19 3.38 19.14C3.2 19.1 3.04 19.01 2.93 18.87C2.75 18.65 2.75 17.76 2.75 16.62V8.46C2.75 7.36 2.76 6.9 2.93 6.61C3.09 6.32 3.47 6.09 4.4 5.55L5.63 4.84C6.34 4.43 6.84 4.14 7.25 3.96V17.3ZM14.25 19.78L10.69 18.02C9.82 17.58 9.3 17.32 8.75 17.23V3.88C9.18 4.03 9.72 4.29 10.51 4.68L13.84 6.34C14 6.42 14.13 6.48 14.25 6.53V19.78ZM21.25 16.91C21.25 18.7 21.24 19.51 20.88 19.87C20.53 20.23 19.74 20.25 18 20.25H15.75V6.83H18C19.74 6.83 20.53 6.84 20.88 7.2C21.24 7.57 21.25 8.38 21.25 10.17V16.91Z"
				fill="currentColor"
			/>
		</svg>
	);
}

MapStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default MapStrokeIcon;
